import { border } from "@chakra-ui/system";

const styles = {
  modal: {
    backgroundColor: "white",
    "&.chakra-ui-dark &": {
      backgroundColor: "gray.800",
    },
    maxWidth: "1200px",
    width: "90%",
  },
  secondaryText: {
    color: "gray.600",
    "&.chakra-ui-dark &": {
      color: "gray.400",
    },
  },
  customSelectStyles: {
    control: (base) => ({
      ...base,
      backgroundColor: "#C41E3A", // teal.400
      borderColor: "white",
      fontWeight: "bold",
      minHeight: "40px",
      borderRadius: "12px",
      "&:hover": {
        borderColor: "white",
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: "white",
      fontWeight: "bold",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#fff",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#2D3748",
      fontWeight: "600",
    }),
    multiValueRemove: (base) => ({
      ...base,
      "&:hover": {
        backgroundColor: "#FC8181",
        color: "white",
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: "white",
      fontWeight: "bold",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#2C7A7B"
        : state.isFocused
        ? "#E6FFFA"
        : "white",
      color: state.isSelected ? "white" : "#2D3748",
    }),
  },

  agGridStyles: `
  .custom-ag-grid.ag-theme-alpine .ag-root-wrapper {
    border-radius: 12px !important;
    overflow: hidden !important;
    border: 1px solid #e2e8f0 !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-header {
    background-color:  #3182ce!important;
    border-top-left-radius: 12px !important;
    border-top-right-radius: 12px !important;
    height: 70px !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-header-row {
    height: 70px !important;
    min-height: 70px !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-header-cell {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    color: #ffffff !important;
    padding: 0 16px !important;
    border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-header-cell:last-child {
    border-right: none !important;
  }

  /* White Filter and Sorting Icons */
  .custom-ag-grid.ag-theme-alpine .ag-icon-filter,
  .custom-ag-grid.ag-theme-alpine .ag-icon-asc,
  .custom-ag-grid.ag-theme-alpine .ag-icon-desc {
    color: #ffffff !important;
    filter: brightness(0) invert(1) !important;
  }

  /* Filter Menu Button */
  .custom-ag-grid.ag-theme-alpine .ag-header-cell-menu-button {
    color: #ffffff !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-header-cell-menu-button:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
  }

  /* Filter Popup Styling */
  .custom-ag-grid.ag-theme-alpine .ag-popup {
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
    background: #ffffff !important;
  }

  /* Filter Input - REMOVE background-image to fix double icons */
  .custom-ag-grid.ag-theme-alpine .ag-input-field-input {
    border: 1px solid #e2e8f0 !important;
    border-radius: 6px !important;
    padding: 8px 12px !important;
    font-size: 14px !important;
    /* REMOVED background-image property */
  }
  .custom-ag-grid.ag-theme-alpine .ag-input-field-input:focus {
    border-color: #3182ce !important;
    outline: none !important;
  }

  /* Filter Select Dropdowns */
  .custom-ag-grid.ag-theme-alpine .ag-filter-select,
  .custom-ag-grid.ag-theme-alpine .ag-filter-condition-select {
    border: 1px solid #e2e8f0 !important;
    border-radius: 6px !important;
    padding: 8px 12px !important;
    font-size: 14px !important;
  }

  /* Filter Buttons */
  .custom-ag-grid.ag-theme-alpine .ag-standard-button {
    border: 1px solid #e2e8f0 !important;
    border-radius: 6px !important;
    padding: 8px 16px !important;
    font-size: 14px !important;
    background: #ffffff !important;
    color: #2d3748 !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-standard-button:hover {
    background: #f7fafc !important;
  }

  /* Filter Apply Panel */
  .custom-ag-grid.ag-theme-alpine .ag-filter-apply-panel {
    border-top: 1px solid #e2e8f0 !important;
    padding-top: 12px !important;
    margin-top: 12px !important;
  }

  .custom-ag-grid.ag-theme-alpine .ag-row {
    height: 64px !important;
    min-height: 64px !important;
    border-bottom: 1px solid #e2e8f0 !important;
    width: 100% !important;
    text-align: left !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-row-even {
    background-color: #f8fafc !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-row-odd {
    background-color: #ffffff !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-cell {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    height: 64px !important;
    padding: 0 8px !important;
    font-size: 16px !important;
    color: #1a202c !important;
    font-weight: 500 !important;
    text-align: left !important;
    white-space: normal !important;
    word-break: break-word !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-cell.ag-numeric-cell {
    justify-content: center !important;
    text-align: center !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-paging-panel {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    padding: 12px !important;
    background-color: #f7fafc !important;
    border-top: 1px solid #e2e8f0 !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-paging-page-summary-panel,
  .custom-ag-grid.ag-theme-alpine .ag-paging-button {
    font-size: 12px !important;
    color: #2d3748 !important;
  }
  .custom-ag-grid.ag-theme-alpine .ag-paging-button:hover {
    background-color: #e2e8f0 !important;
  }
`,
};
// Define color modes for consistency
styles.mode = {
  lightBackground: "#e6f0fa",
  darkBackground: "#1a2a44",
};

export default styles;
